import { useState } from "react";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SiteSettingModalContainer } from "../MapStyled";
import {
  FormControl,
  NativeSelect
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Area } from "pages/Map/MapStyled";
import { useTranslation } from "react-i18next";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import { SiteSetupAction } from "globalStore/globalStore";
import Draggable from "react-draggable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 444,
  bgcolor: "background.paper",
  width: "100%",
  background: "#FFFFFF",
  boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
  borderRadius: "4px",
  outline: "none",
};

const SiteSetupAreasPopups = ({
  modalPos,
  setSiteSetupDialogBox,
  courseNameModel,
  courseNameHandleChange,
  holeNoModel,
  holeCount,
  courseTypeModel,
  courseTypeHandleChange,
  tempPolygon,
  verticesCount,
  siteSetupSaveActiveButton,
  cancelDialogOpen,
  deleteHoleArea,
  saveHoleArea,
  setSiteSetupSaveActiveButton,
  setHoleNoModel,
  areaModified
}) => {
  const { editSiteSetup, addSiteSetup } = useHookstate(SiteSetupAction);
  const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const { t } = useTranslation();

  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const holeNoHandleChange = (e) => {
    setSiteSetupSaveActiveButton(true);
    setHoleNoModel(e.target.value);
    areaModified.set(true);
  }

  const draggableModalStyle = {
    position: "fixed",
    top: modalPos.y,
    left: modalPos.x,
    zIndex: 9999,
    background: "white",
    border: "1px solid #ccc",
    borderRadius: 8,
    width: 300,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    padding: 20
  }

  const modalHeaderStyle = {
    padding: "0px 0px 10px 0px",
    cursor: "move",
    fontWeight: "bold",
    borderBottom: "1px solid #eee"
  }

  const selectLabelStyle = {
    color: "#7c7b7b",
    padding: "0px 0px 5px 0px",
  }

  const verticesStyle = {
    color: "#7c7b7b",
    padding: "0px 0px 5px 0px",
    fontSize: 14
  }

  const buttonsStyle = {
    display: "flex",
    padding: 10,
    gap: 5,
    justifyContent: "center"
  }

  return (
    <>
      <Draggable handle=".modal-header">
        <div style={draggableModalStyle}>
          <SiteSettingModalContainer>
            <div className="modal-header" style={modalHeaderStyle}>
              {editSiteSetup.get() ? t("Edit_Site_Setting") : t("Add_Site_Setting")}
            </div>

            <div style={selectLabelStyle}>
              {t("Select_Hole_and_Area_Type")}
            </div>
            <FormControl fullWidth>
              <NativeSelect
                value={courseNameModel}
                onChange={(e) => courseNameHandleChange(e)}
              >
                {siteSettingsData?.Courses?.map((item) => (
                  <option key={item.Number} value={item.Number}>
                    {item.Name}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>

            <FormControl>
              <Area>
                <NativeSelect
                  value={holeNoModel}
                  onChange={(e) => holeNoHandleChange(e)}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {holeCount &&
                    [...Array(holeCount)].map((elementInArray, index) => (
                      <option key={index} value={index + 1}> {index + 1} </option>
                    ))}
                </NativeSelect>
              </Area>
            </FormControl>

            <FormControl>
              <NativeSelect
                value={courseTypeModel}
                onChange={(e) => courseTypeHandleChange(e)}
              >
                <option value={0}>{t("Tee")}</option>
                <option value={1}>{t("Fairway")}</option>
                <option value={2}>{t("Green")}</option>
                <option value={3}>{t("Extents")}</option>
              </NativeSelect>
            </FormControl>

            <div style={verticesStyle}>
              {t("Vertices")}: {" "}
              {editSiteSetup.get()
                ? verticesCount && verticesCount
                : tempPolygon && tempPolygon.length}
            </div>

            <div style={buttonsStyle}>
              <CircleBtn
                disabled={!siteSetupSaveActiveButton}
                onClick={saveHoleArea}
                className={siteSetupSaveActiveButton ? "active" : "disabled"}
              >
                {t("Save")}
              </CircleBtn>
              <CircleBtn
                disabled={!siteSetupSaveActiveButton && addSiteSetup.get()}
                onClick={() => cancelDialogOpen("cancelModal")}>
                {t("Cancel")}
              </CircleBtn>
              {editSiteSetup.get() ? (
                <CircleBtn onClick={() => { setOpenDeletePopup(true); }}>
                  {t("Delete")}
                </CircleBtn>
              ) : null}
            </div>
          </SiteSettingModalContainer>
        </div>
      </Draggable>

      <Modal
        open={openDeletePopup}
        onClose={() => setOpenDeletePopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="sm"
        sx={{ zIndex: 10001 }}
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>Delete this area?</p>

            <div className="action-btn">
              <button onClick={deleteHoleArea} className="primary">
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  setOpenDeletePopup(false);
                  setSiteSetupDialogBox(null);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
};

export default SiteSetupAreasPopups;
